import React, {useEffect} from 'react';
import {useOktaAuth} from "@okta/okta-react";

const Login = () => {
  // const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    console.log('auth state =>', authState);
    console.log('oktaAuth', oktaAuth)
  }, [authState])


  // if (authState.isPending) {
  //   return
  // }
  console.log('authState =>', authState);

  return (
    <div>
      <h1>Auth</h1>
      {/*{*/}
      {/*  isAuthenticated ?*/}
      {/*    <button onClick={() => logout({returnTo: window.location.origin})} id={'logoutBTN'}>Logout</button>:*/}
      {/*    <button onClick={() => loginWithRedirect()} id={'loginBTN'}>Login</button>*/}
      {/*}*/}

    </div>
  )
}

export default Login;
